import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AppCommonCoreModule } from '@common/app-common-core.module';
import { RegisterBtnsComponent } from '@enus/components/standalone/register-btns/register-btns.component';

@Component({
    selector: 'app-info-register',
    templateUrl: './info-register.component.html',
    styleUrls: ['./info-register.component.scss'],
    standalone: true,
    imports: [CommonModule, AppCommonCoreModule, RegisterBtnsComponent]
})
export class InfoRegisterComponent {
}
